var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from "../box/Box";
import Text from "../text/Text";
import Button from "../button/Button";
import { useAddToBag } from "../hooks/useAddToBag";
import NumberUtil from "../utils/NumberUtil";
import ProductImage from "../image/ProductImage";
import UrlUtil from "../utils/UrlUtil";
var ProductCTA = function (_a) {
    var product = _a.product;
    var product_id = product.product_id, is_apparel = product.is_apparel;
    var _b = useAddToBag(), addToBag = _b.addToBag, isAddingToBag = _b.isAddingToBag;
    var url = UrlUtil.getProductUrl(product);
    var sharedProps = {
        display: "block",
        width: 1,
        size: "medium",
        mb: 2,
    };
    if (is_apparel && url) {
        return React.createElement(Button, __assign({ el: "a", href: url }, sharedProps), "View Sizes");
    }
    return (React.createElement(Button, __assign({}, sharedProps, { disabled: isAddingToBag, onClick: function () { return addToBag({
            product_id: product_id,
            quantity: 1,
            subscription_interval: null,
        }); } }), isAddingToBag ? "Adding..." : "Add to Bag"));
};
var RecommendationItem = function (_a) {
    var item = _a.item, onClick = _a.onClick, rest = __rest(_a, ["item", "onClick"]);
    var product_name = item.product_name, price = item.price, msrp = item.msrp, authority_image_url = item.authority_image_url;
    var isOnSale = msrp > price;
    var url = UrlUtil.getProductUrl(item);
    return (React.createElement(Box, __assign({ display: ["block", "block", "flex"], py: 5, borderTop: "1px solid", borderBottom: "1px solid", borderColor: "grays.1", alignItems: "center" }, rest),
        React.createElement(Box, { display: "flex", flex: "1 1 auto", alignItems: "center", mb: [2, 2, 0] },
            React.createElement(ProductImage, { productUrl: url, imageUrl: authority_image_url, productName: product_name, width: "140px", onClick: onClick }),
            React.createElement(Box, { flex: "1 1 auto", p: 2 },
                React.createElement(Text, { as: "a", href: url, fontWeight: "bold", fontSize: [2, 2, 3], letterSpacing: "-0.03em", mb: 1, onClick: onClick }, product_name),
                isOnSale && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "sr-only" }, "Normally,"),
                    React.createElement(Text, { display: "inline-block", textDecoration: "line-through", color: "grays.4", mr: 2 }, NumberUtil.formatMoney(msrp)),
                    React.createElement("p", { className: "sr-only" }, "Your price today,"))),
                React.createElement(Text, { display: "inline-block", fontWeight: "bold" }, NumberUtil.formatMoney(price)),
                React.createElement(Box, { pt: 6, width: "190px" },
                    React.createElement(ProductCTA, { product: item }))))));
};
export default RecommendationItem;
//# sourceMappingURL=RecommendationItem.js.map